import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class PessoaService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'pessoa');
  }


  listEmpresas(): Observable<any> {
    // return this.http.get(`${this.url_base}/${this.prefixo}?cliente=1&tipo=JURIDICA`);
    return this.http.get(`${this.url_base}/${this.prefixo}?cliente=1`);
  }

  paginate(params = null, page = null): Observable<any> {
    let url = `${this.url_base}/${this.prefixo}/list/all/paginate`;

    if (page !== null) {
      url += '?page=' + page;
    }

    return this.http.post(url, params);
  }

  autocomplete(event = null): Observable<any> {
    return this.http.get(`${this.url_base}/${this.prefixo}/list/auto-complete/${event}`);
  }

}
